export default __webpack_public_path__ + "static/media/img--design-12.09438698.jpg";